// Egyptian Arabic: see ../ARABIC_STYLE.md
import rve from './rve/ar.js';
export default {
  // The video editor (components/Editor)
  rve,
  common: {
    cancel: 'إلغاء',
    scene: 'مشهد {n}',
    sceneSlide: 'مشهد {scene} • شريحة {slide}',
    chars: '{n} حرف',
    unlimited: 'من غير حدود',
    left: 'فاضل {remaining} من {limit}',
    inPro: 'موجود في Pro',
    premiumFeature: 'ميزة مدفوعة',
    limitReached: 'وصلت للحد',
    upgradePlan: 'رقّي باقتك',
    updateFailed: 'التعديل فشل',
    uploadFailed: 'الرفع فشل',
    generationFailed: 'مقدرناش نعملها',
    unexpectedError: 'حصل خطأ مش متوقع.',
    fileUploaded: 'الملف اترفع.',
    pexelsImage: 'اخترت صورة من Pexels.',
    pexelsVideo: 'اخترت فيديو من Pexels.',
    voiceSelection: 'اختيار الصوت',
    regenerateAudio: 'اعمل الصوت من جديد',
    narrationPlaceholder: 'اكتب نص التعليق الصوتي...',
    narrationUpdated: 'التعليق الصوتي اتحدّث',
    audioRegenerated: 'الصوت اتعمل من جديد.',
    captionsUpdated: 'الكابشن اتحدّث',
    updateCaptions: 'حدّث الكابشن',
    editCaptions: 'عدّل الكابشن',
    mediaLibrary: 'مكتبة الميديا',
    mediaLibraryHint: 'دوّر في Pexels أو ارفع ملفاتك.',
    aiTools: 'أدوات AI',
    generateImage: 'اعمل صورة',
    generateImageHint: 'اوصف اللي في دماغك والذكاء الاصطناعي هيعمله من الصفر.',
    prompt: 'الوصف',
    promptPlaceholder: 'لقطة سينمائية لمدينة من المستقبل وقت الغروب...',
    generate: 'اعمل',
    uploadingAsset: 'بنرفع الملف...',
    generatingImage: 'بنعمل الصورة...',
  },

  premium: {
    title: 'افتح مميزات الاستوديو',
    body: 'عمل الصور وتعديلها وتحريكها بالذكاء الاصطناعي موجودين في الباقات المدفوعة.',
    viewPricing: 'شوف الأسعار',
  },

  activity: {
    phases: {
      planning: 'التخطيط',
      concept: 'تطوير الفكرة',
      storyboard: 'الستوري بورد والبحث',
      writing: 'كتابة السكريبت',
      voiceover: 'عمل التعليق الصوتي',
      visuals: 'عمل الصور والمشاهد',
      transcription: 'تفريغ الكلام',
      upload: 'الرفع',
      finalizing: 'اللمسات الأخيرة',
    },
    creating: 'بنعمل الفيديو بتاعك...',
    complete: 'خلصنا!',
    remaining: 'فاضل ~{time}',
    almostDone: 'خلاص قربنا…',
    processing: 'بنشتغل...',
    // What the worker reports, as it words it (the feed shows English as it came;
    // these are for the other languages). A trailing "..." is kept by the feed.
    messages: {
      gettingStarted: 'بنبدأ',
      ready: 'جاهز',
      conceptReady: 'الفكرة جاهزة',
      footageSelected: 'اخترنا اللقطات',
      finalizingScript: 'بنخلّص السكريبت',
      scriptReady: 'السكريبت جاهز',
      voiceovers: 'بنعمل التعليق الصوتي لـ {n} مشاهد',
      voiceoversOne: 'بنعمل التعليق الصوتي لـ {n} مشهد',
      allVoiceoversReady: 'كل التعليق الصوتي جاهز',
      allVisualsReady: 'كل الصور جاهزة',
      visualsReady: 'كل الصور جاهزة ({n})',
      visualsReadyOne: '{n} صورة جاهزة',
      transcribing: 'بنفرّغ الكلام من {n} ملفات صوت',
      transcribingOne: 'بنفرّغ الكلام من {n} ملف صوت',
      transcribed: 'اتفرّغ {n} ملفات صوت',
      transcribedOne: 'اتفرّغ {n} ملف صوت',
      uploadingAssets: 'بنرفع الملفات',
      scenesUploaded: 'اترفع {n} مشاهد',
      scenesUploadedOne: 'اترفع {n} مشهد',
      sceneUploaded: 'مشهد {n}/{total} اترفع',
      wrappingUp: 'بنقفل آخر حاجة',
      videoReady: 'الفيديو بتاعك جاهز',
      failed: 'فشل: {reason}',
      sceneNarration: 'مشهد {n}: “{text}”',
      writingScript: 'بنكتب سكريبت الفيديو بتاعك',
      voiceoversAndVisuals: 'بنعمل التعليق الصوتي والصور',
      transcribingAudio: 'بنفرّغ الكلام',
      finalizingVideo: 'بنخلّص الفيديو بتاعك',
      calculatingDuration: 'بنحسب مدة الفيديو',
      voiceoversComplete: 'التعليق الصوتي خلص، بنعمل الصور',
      sceneVisualsReady: 'صور مشهد {n} جاهزة',
      analyzingIdea: 'بنحلّل فكرتك',
      ideaExpanded: 'الفكرة كبرت! بنبني شكل الفيديو',
      polishingScript: 'بنظبّط السكريبت ونخلّصه',
      scriptComplete: 'السكريبت خلص! بنجهّز المشاهد',
      searchingFootage: 'بندوّر على لقطات مناسبة',
      findingClips: 'بندوّر على أحسن لقطات للفيديو بتاعك',
      curatingVisuals: 'بنختار صور زيادة',
      selectingFootage: 'بنختار أحسن لقطات لكل مشهد',
      scriptAndFootageReady: 'السكريبت واللقطات جاهزين',
      transcriptionComplete: 'التفريغ خلص',
      allAssetsUploaded: 'كل الملفات اترفعت',
      sceneLabel: 'مشهد {n}',
      sceneVoiced: 'مشهد {n} اتسجّل صوته',
    },
  },

  addSlide: {
    dialogTitle: 'ضيف شريحة لمشهد {n}',
    title: 'ضيف شريحة',
    added: 'الشريحة اتضافت',
    addFailed: 'مقدرناش نضيف الشريحة',
    addFailedBody: 'مقدرناش نضيف الشريحة.',
    uploaded: 'الشريحة اترفعت',
    generated: 'الشريحة اتعملت',
    generatedBody: 'شريحة جديدة اتعملت بالذكاء الاصطناعي.',
    limitBody: 'وصلت لحد عمل الشرايح في المشروع ده.',
  },

  asset: {
    dialogTitle: 'عدّل الشريحة - مشهد {scene}، شريحة {slide}',
    studio: 'الاستوديو',
    editSlide: 'عدّل الشريحة',
    invalidDuration: 'مدة مش صحيحة',
    invalidDurationBody: 'لازم تكون رقم أكبر من صفر.',
    durationUpdated: 'المدة اتحدّثت',
    durationSet: 'بقت {n} ث.',
    durationReset: 'المدة رجعت تلقائي',
    durationResetBody: 'رجعت تتحسب تلقائي.',
    replaced: 'الملف اتبدّل',
    replaceFailed: 'مقدرناش نبدّل',
    replaceFailedBody: 'مقدرناش نبدّل الملف.',
    uploaded: 'الملف اترفع',
    regenerated: 'الشريحة اتعملت من جديد',
    regeneratedBody: 'صورة جديدة اتعملت.',
    regenerateLimit: 'وصلت لحد إعادة العمل في المشروع ده.',
    edited: 'الشريحة اتعدّلت',
    editedBody: 'الصورة اتحدّثت.',
    editLimit: 'وصلت لحد التعديل في المشروع ده.',
    editFailed: 'التعديل فشل',
    animateLimit: 'وصلت لحد التحريك في المشروع ده.',
    animationFailed: 'التحريك فشل',
    editImage: 'عدّل الصورة',
    animateVideo: 'حرّكها لفيديو',
    editImageHint: 'عدّل الشريحة دي بكلام عادي، اكتب اللي عايزه.',
    previewAlt: 'معاينة الشريحة الحالية',
    editingNote: 'انت بتعدّل صورة الشريحة الحالية. الذكاء الاصطناعي هيحافظ على تكوين الصورة على قد ما يقدر.',
    editInstructions: 'التعديل المطلوب',
    editPlaceholder: 'خليها بالليل، زوّد مطر، غيّر لون العربية...',
    applyEdits: 'طبّق التعديل',
    animateTitle: 'حرّك الشريحة دي',
    animateHint: 'بتحوّل الصورة لمقطع 5 ثواني بيتحرك مكانها.',
    animate: 'حرّك',
    currentAsset: 'الملف الحالي',
    assetAlt: 'ملف الشريحة الحالي',
    badgeVideo: 'فيديو',
    badgeImage: 'صورة',
    screenTime: 'مدة الظهور',
    auto: 'تلقائي',
    seconds: 'ث',
    set: 'ظبّط',
    autoSyncing: 'متظبطة تلقائي على التعليق الصوتي ({n} ث).',
    details: 'التفاصيل',
    resolution: 'الجودة',
    ratio: 'المقاس',
    enhancingImage: 'بنحسّن الصورة...',
    animatingVideo: 'بنحرّك الشريحة…',
    animatingWait: '{n} ثانية · عادةً من 15 لـ 40 ثانية',
    animateAgain: 'حرّكها تاني',
    animateAgainTitle: 'حرّكها تاني',
    stillNote: 'الصورة دي هتبقى أول لقطة في المقطع، وتقدر ترجع لها بعدين.',
    animatedNote: 'الشريحة دي متحرّكة. جرّب حركة تانية من نفس الصورة، أو ارجع للصورة.',
    backToPicture: 'ارجع للصورة',
    animateTime: 'بتاخد من 15 لـ 40 ثانية.',
    animated: 'الشريحة اتحرّكت',
    animatedBody: 'بقت شغالة في الفيديو. مش عاجباك؟ جرّب حركة تانية أو ارجع للصورة.',
    restored: 'رجعنا للصورة',
    restoreFailed: 'معرفناش نرجع للصورة',
    restoring: 'بنرجّع الصورة…',
  },

  animateAll: {
    animating: 'بنحرّك الشرايح',
    complete: 'الشرايح اتحرّكت',
    stopped: 'وقّفنا',
    noneWorked: 'معرفناش نحرّك الشرايح',
    keepsGoing: 'تقدر تقفل الشاشة دي: الشغل مكمّل، وكل شريحة بتتغيّر في الفيديو أول ما تخلص.',
    inProject: 'المقاطع الجديدة بقت في الفيديو بتاعك. افتح أي شريحة لو عايز تجرّب حركة تانية أو ترجع للصورة.',
    progress: '{current} من {total} اتحرّكت',
    leftSeconds: 'فاضل حوالي {n} ثانية',
    leftMinutes: 'فاضل حوالي {n} دقيقة',
    failed: 'معرفناش نحرّك {n}',
    stop: 'وقّف',
    stopping: 'هنقف بعد دي…',
    hide: 'خبّيها',
    retry: 'جرّب الـ {n} تاني',
    done: 'تمام',
  },

  voiceConfirm: {

    paidOnly: 'تغيير صوت فيديو خلصان في الباقات المدفوعة بس. تقدر تختار أي صوت قبل ما تعمل الفيديو الجاي.',

    seePlans: 'شوف الباقات',
    seconds: '~{n} ثانية',
    minuteOne: '~{n} دقيقة',
    minuteMany: '~{n} دقايق',
    title: 'تغيّر الصوت لكل المشاهد؟',
    description: 'ده هيعمل الصوت من جديد لكل المشاهد بالصوت الجديد.',
    change: 'تغيير الصوت:',
    impactOne: 'ده هيعمل الصوت من جديد لـ {n} مشهد',
    impactMany: 'ده هيعمل الصوت من جديد لـ {n} مشاهد',
    creditsOne: 'هيستخدم {n} من رصيد إعادة عمل الصوت',
    creditsMany: 'هيستخدم {n} من رصيد إعادة عمل الصوت',
    time: 'الوقت المتوقع: {time}',
    canLeave: 'بيتعمل عندنا على السيرفر: تقدر تقفل الصفحة',
    canUndo: 'تقدر ترجع للصوت الحالي بعدها ببلاش',
    currentUsage: 'استخدامك دلوقتي:',
    afterChange: 'بعد التغيير ده:',
    remaining: 'فاضل {n}',
    confirm: 'أكّد واعمل الصوت',
  },

  narration: {
    dialogTitle: 'عدّل التعليق الصوتي - مشهد {n}',
    title: 'عدّل التعليق الصوتي',
    script: 'السكريبت',
    hint: 'عدّل النص اللي تحت عشان نعمل التعليق الصوتي من جديد.',
  },

  scene: {
    dialogTitle: 'تعديل المشهد - مشهد {n}',
    title: 'تعديل المشهد',
    narrationTab: 'التعليق الصوتي والصوت',
    mobileTitle: 'عدّل مشهد {n}',
    script: 'سكريبت التعليق الصوتي',
    hint: 'عدّل النص عشان نعمل التعليق الصوتي بالذكاء الاصطناعي من جديد.',
    voiceLimit: 'وصلت لحد إعادة عمل الصوت في المشروع ده.',
    captionsBody: 'التوقيت اتظبط تلقائي.',
    timingTitle: 'توقيت الكابشن',
    timingHint: 'صلّح غلطات التفريغ. التوقيت بيتظبط تلقائي.',
    timingWarning: 'التعديل هنا بيأثر على ظهور الكابشن. خلّي عدد الكلمات زي ما هو عشان أحسن نتيجة.',
  },

  motion: {
    // How an animated slide moves (components/AIAgent/MotionPicker.jsx)
    label: 'عايزها تتحرك إزاي؟',
    picture: 'زي وصف الصورة',
    pictureHint: 'بتتحرك حسب الوصف اللي اتعملت بيه الصورة',
    subtle: 'حركة خفيفة',
    subtleHint: 'الصورة تصحى والكاميرا ثابتة',
    zoom: 'زووم بطيء',
    zoomHint: 'الكاميرا بتقرّب بالراحة من البطل',
    subject: 'الشخصية تتحرك',
    subjectHint: 'الناس والحيوانات بتتنفّس وترمش وتتحرك',
    dramatic: 'حركة قوية',
    dramaticHint: 'الكاميرا بتلف والمشهد كله بيتحرك',
    custom: 'اوصفها بنفسك',
    customHint: 'قول بكلامك هتتحرك إزاي',
    customPlaceholder: 'مثلاً: التلج بينزل بالراحة والفانوس بينوّر ويطفي',
  },

  slides: {
    title: 'حرّك الشرايح',
    subtitle: 'اختار الصور اللي عايزها تبقى مقاطع قصيرة بتتحرك. كل واحدة بتاخد حوالي 20 ثانية.',
    pick: 'الصور اللي هتتحرك',
    picked: 'اخترت {selected} من {total}',
    selectAll: 'اختار الكل',
    clear: 'امسح الاختيار',
    left: 'فاضلك {remaining} من {limit} تحريك في المشروع ده',
    noneLeft: 'خلّصت كل التحريكات بتاعة المشروع ده.',
    upgrade: 'رقّي باقتك',
    allMoving: 'كل الشرايح في الفيديو ده بتتحرك خلاص.',
    movingOne: '{n} شريحة بتتحرك خلاص (مقطع فيديو أو تحريك)، علشان كده مش ظاهرة.',
    movingMany: 'عدد الشرايح اللي بتتحرك خلاص: {n} (مقاطع فيديو أو تحريك)، علشان كده مش ظاهرة.',
    underMinute: 'أقل من دقيقة',
    aboutMinutes: 'حوالي {n} دقيقة',
    pickFirst: 'اختار شرايح تتحرك',
    animateOne: 'حرّك {n} شريحة',
    animateMany: 'حرّك {n} شرايح',
    thumbAlt: 'مشهد {scene} - شريحة {slide}',
  },

  captionsEdit: {
    confirm: 'فيه تغييرات كبيرة، والتوقيت ممكن يتأثر. تكمّل؟',
    updatedBody: 'التوقيت اتظبط تلقائي.',
    dialogTitle: 'عدّل الكابشن - مشهد {n}',
    subtitle: 'مشهد {n} • متظبط على الصوت',
    warning: 'تعديل النص هنا هيظبط توقيت الكابشن تلقائي. حاول تخلّي عدد الكلمات قريب عشان الإيقاع يفضل زي ما هو.',
    placeholder: 'اكتب نص الكابشن...',
    words: '{n} كلمة',
    autoSync: 'الضبط التلقائي شغال',
  },

  voicePicker: {
    title: 'اختار صوت التعليق الصوتي',
    description: 'اختار صوت للتعليق الصوتي في الفيديو بتاعك',
    confirm: 'تأكيد',
  },

  // Caption style controls (VideoStudio), shared with the other editors
  captionStyle: {
    previewYour: 'دي',
    previewStory: 'قصتك',
    templates: {
      keyword: 'الكلمة المهمة',
      minimal: 'بسيط',
      neon: 'نيون',
      tiktok: 'تيك توك',
      comic: 'كوميك',
      elegant: 'أنيق',
      glitch: 'جليتش',
      bold: 'عريض',
      clean: 'نضيف',
      outline: 'محدد',
      punch: 'ضربة',
      redbox: 'مربع أحمر',
      boxed: 'في مربع',
      podcast: 'بودكاست',
      pop: 'بوب',
      mint: 'نعناع',
    },
    position: 'المكان',
    fontText: 'الخط والنص',
    colors: 'الألوان',
    text: 'النص',
    highlight: 'التمييز',
    stroke: 'الإطار',
    background: 'الخلفية',
    animationTiming: 'الحركة والتوقيت',
    speed: 'السرعة',
    speedAria: 'سرعة تجميع الكلمات',
    words: 'الكلمات',
    wordsAria: 'أقصى عدد كلمات في الصفحة',
    spacing: 'المسافات',
    lineHeight: 'المسافة بين السطور',
    letterSpacing: 'المسافة بين الحروف',
    transforms: 'التحويلات',
    rotation: 'الدوران',
    skew: 'الميل',
    scale: 'الحجم',
  },

  // البحث في Pexels ورفع الملفات جوه نوافذ المشاهد
  mediaPicker: {
    searchTab: 'دوّر في Pexels',
    uploadTab: 'ارفع ملف',
    images: 'صور',
    videos: 'فيديوهات',
    searchImages: 'دوّر على صور…',
    searchVideos: 'دوّر على فيديوهات…',
    search: 'دوّر',
    orientation: 'الاتجاه',
    anyOrientation: 'أي اتجاه',
    landscape: 'أفقي',
    portrait: 'رأسي',
    square: 'مربع',
    size: 'الحجم',
    anySize: 'أي حجم',
    small: 'صغير',
    medium: 'متوسط',
    large: 'كبير',
    foundImages: 'عدد الصور: {count}',
    foundVideos: 'عدد الفيديوهات: {count}',
    page: 'صفحة {page}',
    previousPage: 'الصفحة اللي فاتت',
    nextPage: 'الصفحة اللي بعدها',
    promptImagesTitle: 'دوّر على صور',
    promptVideosTitle: 'دوّر على فيديوهات',
    promptImagesBody: 'اكتب فوق اللي محتاجه وهتلاقي صور مجانية من Pexels.',
    promptVideosBody: 'اكتب فوق اللي محتاجه وهتلاقي فيديوهات مجانية من Pexels.',
    noImages: 'مفيش صور لـ «{query}»',
    noVideos: 'مفيش فيديوهات لـ «{query}»',
    select: 'اختار',
    photoBy: 'صورة من {name}',
    videoBy: 'فيديو من {name}',
    by: 'من {name}',
    poweredBy: 'من',
    uploadTitle: 'ارفع حاجة من عندك',
    uploadImage: 'اختار صورة من جهازك.',
    uploadVideo: 'اختار فيديو من جهازك.',
    uploadBoth: 'اختار صورة أو فيديو من جهازك.',
    chooseFile: 'اختار ملف',
    previewImage: 'شوف الصورة',
    previewVideo: 'شوف الفيديو',
    close: 'قفل',
    cancel: 'إلغاء',
    addImage: 'استخدم الصورة دي',
    addVideo: 'استخدم الفيديو ده',
    loadFailedTitle: 'معرفناش نجيب النتايج',
    loadFailedBody: 'Pexels مردّش. جرّب تاني كمان شوية.',
    wrongTypeTitle: 'الملف ده مينفعش هنا',
    wrongTypeImage: 'اختار ملف صورة.',
    wrongTypeVideo: 'اختار ملف فيديو.',
    wrongTypeBoth: 'اختار صورة أو فيديو.',
  },
};
